<template>
  <div class="profile-page">
    <el-card>
      <div slot="header">
        <h2>个人中心</h2>
      </div>

      <el-form :model="userInfo" :rules="userRules" ref="userInfo" label-width="120px" class="profile-form">
        <el-form-item label="账号" prop="username">
          <el-input v-model="userInfo.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="userInfo.name" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="userInfo.email" maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="userInfo.phone" maxlength="11"
            @input="userInfo.phone = userInfo.phone.replace(/[^\d]/g, '')"></el-input>
        </el-form-item>
        <el-form-item label="头像">
          <el-upload class="avatar-uploader" action="" :auto-upload="false" :on-change="handleAvatarChange"
            :show-file-list="false">
            <img v-if="userInfo.avatar" :src="userInfo.avatar" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="avatar-tip">提示：选择头像后需点击"保存修改"生效</div>
        </el-form-item>
        <!-- 分割线 -->
        <div style="margin: 20px 0;"></div>
        <!-- 修改密码功能（默认隐藏，通过按钮控制展开） -->
        <el-form-item>
          <el-button type="success" v-hasPermission="'profile:password'" @click="showPasswordForm = !showPasswordForm"
            :icon="showPasswordForm ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
            {{ showPasswordForm ? '收起密码修改' : '修改密码' }}
          </el-button>
        </el-form-item>
        <!-- 密码修改表单（条件渲染） -->
        <el-form v-if="showPasswordForm" :model="passwordForm" ref="passwordForm" :rules="passwordRules"
          label-width="120px" class="password-form">
          <el-form-item label="当前密码" prop="currentPassword">
            <el-input v-model="passwordForm.currentPassword" type="password" show-password maxlength="30"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input v-model="passwordForm.newPassword" type="password" show-password maxlength="30"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="confirmPassword">
            <el-input v-model="passwordForm.confirmPassword" type="password" show-password maxlength="30"></el-input>
          </el-form-item>
        </el-form>
        <el-form-item>
          <el-button type="primary" @click="saveProfile">保存修改</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <!-- 头像裁剪弹窗 -->
    <el-dialog title="裁剪头像" :visible.sync="showCropper" width="600px" :close-on-click-modal="false">
      <div class="cropper-container">
        <vue-cropper ref="cropper" :img="cropperImg" :info="true" :autoCrop="true" :autoCropWidth="200"
          :autoCropHeight="200" :fixed="true" :fixedNumber="[1, 1]" :canMove="false" :canMoveBox="true"
          :original="false" :centerBox="true" :height="300" :outputType="'jpeg'"></vue-cropper>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelCrop">取消</el-button>
        <el-button type="primary" @click="confirmCrop">确认裁剪</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import userApi from '../api/user'
import { VueCropper } from 'vue-cropper'

export default {
  name: 'Profile',
  components: {
    VueCropper // 注册组件
  },
  data() {
    return {
      userInfo: {
        id: null,
        username: '',
        name: '',
        email: '',
        phone: '',
        avatar: ''
      },
      tempAvatarFile: null,
      showCropper: false,
      cropperImg: '',
      originalAvatar: '',
      showPasswordForm: false,
      passwordForm: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      userRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 1, max: 20, message: '姓名长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: '请输入正确的邮箱格式', trigger: ['blur', 'change'] },
          { min: 1, max: 30, message: '邮箱长度在 1 到 30 个字符', trigger: 'blur' }
        ],
        phone: [
          { min: 11, max: 11, message: '手机号长度必须为11位', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
        ]
      },
      passwordRules: {
        currentPassword: [
          { required: true, message: '请输入当前密码', trigger: 'blur' },
          { min: 6, max: 30, message: '密码长度在 6 到 30 个字符', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 30, message: '密码长度在 6 到 30 个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { min: 6, max: 30, message: '密码长度在 6 到 30 个字符', trigger: 'blur' },
          { validator: this.validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.loadUserInfo()
  },
  methods: {
    loadUserInfo() {
      userApi.getCurrentUser().then(response => {
        if (response.success) {
          this.userInfo = { ...response.data }
          // 如果没有头像，使用默认头像
          if (!this.userInfo.avatar) {
            this.userInfo.avatar = require('../assets/avatar-default.png')
          }
        }
      })
    },

    handleAvatarChange(file) {
      // 先执行格式和大小验证
      const isValid = this.beforeAvatarUpload(file.raw);
      if (!isValid) {
        return; // 验证不通过，终止流程
      }
      // 保存原始头像用于取消时恢复
      this.originalAvatar = this.userInfo.avatar;
      // 生成裁剪图片的URL
      this.cropperImg = URL.createObjectURL(file.raw);
      // 显示裁剪弹窗
      this.showCropper = true;
    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    // 取消裁剪
    cancelCrop() {
      this.showCropper = false;
      // 恢复原始头像
      this.userInfo.avatar = this.originalAvatar;
      // 释放URL对象
      URL.revokeObjectURL(this.cropperImg);
      this.cropperImg = '';
    },

    // 确认裁剪
    confirmCrop() {
      // 获取裁剪后的图片（blob格式）
      this.$refs.cropper.getCropBlob(blob => {
        if (blob) {
          // 保存裁剪后的文件
          this.tempAvatarFile = blob;
          // 生成预览URL
          this.userInfo.avatar = URL.createObjectURL(blob);
        }
      });
      // 关闭弹窗
      this.showCropper = false;
    },

    // 验证两次密码是否一致
    validateConfirmPassword(rule, value, callback) {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    },

    saveProfile() {
      this.$refs.userInfo.validate(valid => {
        if (valid) {
          // 构建FormData（支持文件上传）
          const formData = new FormData()
          // 追加用户基本信息
          formData.append('id', this.userInfo.id)
          formData.append('name', this.userInfo.name)
          formData.append('email', this.userInfo.email)
          formData.append('phone', this.userInfo.phone)
          // 处理裁剪后的头像文件（转换为File对象）
          if (this.tempAvatarFile && this.tempAvatarFile instanceof Blob) {
            // 转换blob为File对象，以便后端正确接收
            const file = new File([this.tempAvatarFile], 'avatar.jpg', {
              type: 'image/jpeg',
              lastModified: Date.now()
            });
            formData.append('avatarFile', file);
          }
          userApi.updateProfile(this.userInfo.id, formData).then(response => {
            if (response.success) {
              this.tempAvatarFile = null
              // 判断是否需要处理密码修改
              // 条件：密码表单已显示，或任意密码字段有输入
              const needChangePassword =
                this.showPasswordForm ||
                this.passwordForm.currentPassword ||
                this.passwordForm.newPassword ||
                this.passwordForm.confirmPassword;
              if (needChangePassword) {
                // 修改密码
                this.$refs.passwordForm.validate(valid => {
                  if (valid) {
                    // 组装请求参数
                    const params = {
                      userId: this.userInfo.id,
                      currentPassword: this.passwordForm.currentPassword,
                      newPassword: this.passwordForm.newPassword
                    };
                    userApi.changePassword(params).then(response => {
                      if (response.success) {
                        this.$message.success(response.message || '个人信息更新成功');
                        // 清空密码表单
                        this.passwordForm = {
                          currentPassword: '',
                          newPassword: '',
                          confirmPassword: ''
                        }
                        // 跳转到登录页
                        this.$router.push('/login')
                      } else {
                        this.$message.error('密码修改失败：' + response.message)
                      }
                    })
                  }
                })
              } else {
                this.$message.success(response.message || '个人信息更新成功');
                // 跳转到登录页
                this.$router.push('/login')
              }
            } else {
              this.$message.error('更新失败：' + response.message)
            }
          })
        }
      })
    },

    resetPasswordForm() {
      this.passwordForm = {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    },

    beforeDestroy() {
      // 释放所有可能的URL对象
      if (this.userInfo.avatar && this.tempAvatarFile) {
        URL.revokeObjectURL(this.userInfo.avatar)
      }
      if (this.cropperImg) {
        URL.revokeObjectURL(this.cropperImg)
      }
    }
  },

  watch: {
    // 监听表单显示状态，收起时重置输入
    showPasswordForm(val) {
      if (!val) {
        this.resetPasswordForm()
      }
    }
  }
}
</script>

<style scoped>
.profile-page {
  padding: 20px;
}

.profile-form {
  max-width: 600px;
  margin: 0 auto;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: cover;
}

.avatar-tip {
  margin-top: 10px;
  color: #666;
  font-size: 12px;
}

.cropper-container {
  width: 100%;
  height: 300px;
}
</style>
